import React from "react";
import { useSelector } from "react-redux";
import { Select, DatePicker } from "antd";
import { formattedPlayerName } from "@utils/name_utils";
import { useStatusTrackerV2 } from "../hooks/useStatusTrackerV2";
import { buildFlagTypeOptions } from "../mappers/flags.mapper";

// Filter row: month picker + player / position / group / status / flag-type selects (options-based).
export const FilterBar = () => {
    const { state, team, setFilter } = useStatusTrackerV2();
    const { players, positions, playerGroups, teamName } = team;
    const {
        playersFilter,
        positionsFilter,
        playerGroupsFilter,
        playerStatusesFilter,
        flagTypesFilter,
        selectedMonth,
    } = state.filters;
    const statuses = state.statuses;

    const udfFlags = useSelector(({ userDefinedFlags }) => userDefinedFlags?.flags || []);
    const flagTypeOptions = buildFlagTypeOptions(udfFlags);

    const handle = (key) => (value) => setFilter({ [key]: value });
    const onMonthChange = (date) => setFilter({ selectedMonth: date });

    const byLabel = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
        <div className="stv2-tracker-filter-container">
            <div>
                <DatePicker
                    value={selectedMonth}
                    style={{ marginLeft: "10px" }}
                    onChange={onMonthChange}
                    picker="month"
                    allowClear={false}
                    format={"MMM YYYY"}
                />
            </div>
            <div>
                <Select
                    allowClear
                    showSearch
                    style={{ width: 290, marginLeft: "10px" }}
                    placeholder="Choose Players"
                    value={playersFilter}
                    onChange={handle("playersFilter")}
                    filterOption={byLabel}
                    mode="multiple"
                    maxTagCount={1}
                    options={(players || []).map((p, i) => ({
                        key: i,
                        value: p.player_id,
                        label: `${formattedPlayerName(teamName, p.first_name + " " + p.last_name)} #${p.number}`,
                    }))}
                />
            </div>
            <div>
                <Select
                    allowClear
                    showSearch
                    style={{ width: 235, marginLeft: "10px" }}
                    placeholder="Choose Positions"
                    value={positionsFilter}
                    onChange={handle("positionsFilter")}
                    filterOption={byLabel}
                    mode="multiple"
                    maxTagCount={3}
                    options={(positions || []).map((pos, i) => ({ key: i, value: pos, label: pos }))}
                />
            </div>
            <div>
                <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Choose Player Groups"
                    value={playerGroupsFilter}
                    style={{ width: 225, marginLeft: "10px" }}
                    onChange={handle("playerGroupsFilter")}
                    mode="multiple"
                    maxTagCount={1}
                    options={(playerGroups || []).map((pg, i) => ({
                        key: i,
                        value: pg?.player_group_id,
                        label: pg?.name,
                    }))}
                />
            </div>
            <div>
                <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Choose Player Statuses"
                    value={playerStatusesFilter}
                    style={{ width: 210, marginLeft: "10px" }}
                    onChange={handle("playerStatusesFilter")}
                    mode="multiple"
                    maxTagCount={2}
                    options={(statuses || []).map((s, i) => ({ key: i, value: s?.id, label: s?.name }))}
                />
            </div>
            <div>
                <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Choose Flags"
                    value={flagTypesFilter}
                    style={{ width: 210, marginLeft: "10px" }}
                    onChange={handle("flagTypesFilter")}
                    filterOption={byLabel}
                    mode="multiple"
                    maxTagCount={2}
                    options={flagTypeOptions}
                />
            </div>
        </div>
    );
};
